<template>
  <button @click="ulozMisatZPark4night">⬇️ Ulož místa z P4night</button>
</template>

<script setup>
import { inject } from "vue";
import { LadzoConsole as Lc } from "../../js/global/ladzo-console.js";
import { Url } from "../../js/class/Url.js";
//import { Url } from "../../js/class/Url.js";
import Swal from "sweetalert2";

const map = inject("map");
const toast = inject("toast");
const hideSidebar = inject("hideSidebar");

const getMapArea = inject("getMapArea");

const nactiMista = inject("Mista.nactiMista");

function ulozMisatZPark4night() {
  if (!map) {
    Lc.e("map není k dispozici");
    return;
  }

  Swal.fire({
    title: "Získat místa z park4night?",
    text: "Nepoužívat tuto akci příliš často",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Ano",
    cancelButtonText: "Ne",
    customClass: {
      popup: "swal-sm",
      confirmButton: "btn-ok",
      cancelButton: "btn-cancel",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      //iskani aktualni oblasti
      const area = getMapArea?.();
      const centerLat = area.center[0];
      const centerLng = area.center[1];
      Lc.h("area", area);

      //const centerLat = (sw.lat + ne.lat) / 2;
      //const centerLng = (sw.lng + ne.lng) / 2;
      Lc.log("Akce potvrzena! Střed mapy 2:", [centerLat, centerLng]);

      //Lc.log(Url.PARK4NIGHT_ULOZ_MISTA);
      //Lc.log(Url);

      const url = `${Url.PARK4NIGHT_ULOZ_MISTA}?json&lat=${centerLat}&lng=${centerLng}`;

      //toast.value.showToast("Byly načteny nové místa z park4night", "success");
      Lc.log(url);

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Chyba sítě: " + response.status);
          }
          return response.json(); // nebo .text(), pokud není JSON
        })
        .then((data) => {
          Lc.log(data);
          toast.value.showToast(
            "Byly načteny nové místa z park4night",
            "success"
          );
        })
        .catch((error) => {
          Lc.err("Došlo k chybě:", error);
          toast.value.showToast("Došlo k chybě: " + error, "error"); //toast.value.showToast("Byly načteny nové místa z park4night", "error");
        });
    }
    Lc.log("--");
    nactiMista?.();
  });
}
function zobrazOblast() {
  if (!map) {
    Lc.e("map není k dispozici");
    return;
  }

  const area = getMapArea?.();

  Lc.log("Oblast OK, volám API pro 2:", area);

  //toast.value.showToast("Souřadnice zobrazeny v konzoli", "success");
  toast?.value?.showToast("Souřadnice zobrazeny v konzoli", "error");

  hideSidebar?.();
}
</script>
